import { getSessionAndFavorites } from "@/sections/buscar/getSessionAndFavorites";
import { parseSearchQuery } from "@/sections/buscar/parseSearchQuery";

import BuscarLayout from "./BuscarLayout";

export async function getServerSideProps(context) {
    const initialParams = parseSearchQuery(context.query);
    const { session, favorites } = await getSessionAndFavorites(context);
    return { props: { initialParams, favorites, session } };
}

const BuscarPage = ({ initialParams, favorites, session }) => {
    return <BuscarLayout initialParams={initialParams} favorites={favorites} session={session} />;
};

export default BuscarPage;
